import { DataSecurityMonitorType } from '@sonar-software/sonar-core';
import React from 'react';
import { SETTINGS_DATA_SECURITY_COPY } from '@sonar-software/sonar-ts-constants';
import { Tag } from 'antd';

const monitorTypeColors: Record<number, string> = {
	[ DataSecurityMonitorType.NewObjectAndFieldAccess ]: 'cyan',
	[ DataSecurityMonitorType.NewUser ]: 'green',
	[ DataSecurityMonitorType.Uptime ]: 'magenta',
	[ DataSecurityMonitorType.Personal ]: 'blue',
	[ DataSecurityMonitorType.SetupAuditTrail ]: 'orange'
};

export const monitorTypeLabel: Record<number, string> = {
	[ DataSecurityMonitorType.NewObjectAndFieldAccess ]: SETTINGS_DATA_SECURITY_COPY.OBJECT_AND_FIELD_ACCESS,
	[ DataSecurityMonitorType.NewUser ]: SETTINGS_DATA_SECURITY_COPY.NEW_USER,
	[ DataSecurityMonitorType.Uptime ]: SETTINGS_DATA_SECURITY_COPY.UPTIME,
	[ DataSecurityMonitorType.Personal ]: SETTINGS_DATA_SECURITY_COPY.PERSONAL,
	[ DataSecurityMonitorType.SetupAuditTrail ]: SETTINGS_DATA_SECURITY_COPY.SETUP_AUDIT_TRAIL
};

export const monitorParentType: Partial<Record<DataSecurityMonitorType, DataSecurityMonitorType>> = {
	[ DataSecurityMonitorType.NewApp ]: DataSecurityMonitorType.Personal,
	[ DataSecurityMonitorType.Following ]: DataSecurityMonitorType.Personal,
	[ DataSecurityMonitorType.TimelineSummary ]: DataSecurityMonitorType.Personal,
	[ DataSecurityMonitorType.NewObjectAndFieldAccess ]: DataSecurityMonitorType.NewObjectAndFieldAccess,
	[ DataSecurityMonitorType.ConfigurableFieldAccess ]: DataSecurityMonitorType.NewObjectAndFieldAccess
};

export interface MonitorTypeTagProps {
	monitorTypeId: number | undefined;
}

export const MonitorTypeTag: React.FC<MonitorTypeTagProps> = ({ monitorTypeId }) => {
	if (!Number.isInteger(monitorTypeId)) {
		return null;
	}

	const id = monitorParentType[ monitorTypeId as DataSecurityMonitorType ] ?? monitorTypeId;
	const label = monitorTypeLabel[ id as DataSecurityMonitorType ];
	const color = monitorTypeColors[ id as DataSecurityMonitorType ];

	return <Tag color={ color }>{ label }</Tag>;
};
